export default __webpack_public_path__ + "static/media/njxxd.b921dfe5.png";